// Utilities for VNEC v9 forms (match v9 schema — lowercase enum)

export function formatVND(n) {
  return new Intl.NumberFormat('vi-VN').format(Math.round(Number(n) || 0));
}
export function parseVND(s) {
  return Number(String(s || '').replace(/\D/g, '')) || 0;
}
export function formatDate(iso) {
  if (!iso) return '';
  return new Date(iso).toLocaleDateString('vi-VN');
}
export function todayISO() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}
export function thisMonthISO() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
}

// ── State labels (v9 lowercase enum) ──
const STATE_MAP = {
  draft:      ['Nháp',         'state-draft'],
  pending_l1: ['Chờ duyệt L1',  'state-pending'],
  pending_l2: ['Chờ duyệt L2',  'state-pending'],
  approved:   ['Đã duyệt',      'state-approved'],
  rejected:   ['Từ chối',       'state-rejected'],
  cancelled:  ['Đã hủy',        'state-rejected']
};
export function stateLabel(state) {
  const [label, cls] = STATE_MAP[state] || [state || '—', ''];
  return `<span class="state-badge ${cls}">${label}</span>`;
}
// FE cần danh sách state để render filter dropdown
export const STATES_LIST = [
  { value: 'draft',      label: 'Nháp' },
  { value: 'pending_l1', label: 'Chờ duyệt L1' },
  { value: 'pending_l2', label: 'Chờ duyệt L2' },
  { value: 'approved',   label: 'Đã duyệt' },
  { value: 'rejected',   label: 'Từ chối' },
  { value: 'cancelled',  label: 'Đã hủy' }
];

export function ifrsTag(phan_loai) {
  const colors = {
    Contract_Direct: '#1a5c2e',
    Contract_Allocated: '#2c5c8a',
    Obtain_Contract: '#8a5c2c',
    Operating_SGA: '#5c2c8a',
    Inventory: '#c9a24a',
    Prepaid: '#8a2c5c'
  };
  const c = colors[phan_loai] || '#666';
  return `<span class="ifrs-tag" style="background:${c}1a;color:${c};border:1px solid ${c}44">${phan_loai || '—'}</span>`;
}

// ── Form serialization ──
export function serializeForm(form) {
  const fd = new FormData(form);
  const obj = {};
  for (const [k, v] of fd.entries()) {
    if (v === '') continue;
    obj[k] = v;
  }
  return obj;
}

export function fieldsetDisabled(form, disabled) {
  form.querySelectorAll('input:not([readonly]), select, textarea, button').forEach(el => {
    el.disabled = disabled;
  });
}

export function cleanEmptyFields(payload, fields) {
  fields.forEach(k => {
    if (payload[k] === '' || payload[k] == null) delete payload[k];
  });
  return payload;
}

export function attachVNDFormat(input) {
  input.addEventListener('input', () => {
    const raw = input.value.replace(/\D/g, '');
    input.value = raw ? formatVND(raw) : '';
    input.setSelectionRange(input.value.length, input.value.length);
  });
}

export function numFields(obj, fields) {
  fields.forEach(k => {
    if (obj[k] != null) {
      const v = typeof obj[k] === 'string' ? parseVND(obj[k]) : Number(obj[k]);
      obj[k] = isNaN(v) ? 0 : v;
    }
  });
  return obj;
}

export function budgetBadge(pct) {
  if (pct >= 110) return `<span class="state-badge state-rejected">⛔ ${pct}%</span>`;
  if (pct >= 80) return `<span class="state-badge state-pending">⚠ ${pct}%</span>`;
  return `<span class="state-badge state-approved">${pct}%</span>`;
}

// HTML escape
export function esc(s) {
  return String(s ?? '').replace(/[&<>"']/g, c => ({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c]));
}
